/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from 'rxjs/operators';
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
} from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from '@angular/common/http';
import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ProductServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * 获取产品信息
   * @param id (optional) 产品Id
   * @return Success
   */
  get(
    id: number | null | undefined,
    code: string | null | undefined
  ): Observable<ProductDto> {
    let url_ = this.baseUrl + '/api/services/app/Product/Get?';
    if (id !== undefined && id !== null)
      url_ += 'id=' + encodeURIComponent('' + id) + '&';
    if (code !== undefined && code !== null)
      url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(<any>response_);
            } catch (e) {
              return <Observable<ProductDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ProductDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ProductDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver).result;
          result200 = ProductDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProductDto>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getAttachmentUrl(id: number | undefined): Observable<string> {
    let url_ = this.baseUrl + '/api/services/app/Product/GetAttachmentUrl?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAttachmentUrl(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAttachmentUrl(<any>response_);
            } catch (e) {
              return <Observable<string>>(<any>_observableThrow(e));
            }
          } else return <Observable<string>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAttachmentUrl(
    response: HttpResponseBase
  ): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver).result;
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(<any>null);
  }
}

export enum AttachmentType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
}

export class AttachmentDto implements IAttachmentDto {
  /** 附件名称 */
  name: string | undefined;
  type: AttachmentType;
  /** 产品型号 */
  modelId: number;
  /** 附件大小Kb */
  size: number;
  /** 文件扩展名 */
  extension: string | undefined;
  /** 文件地址 */
  fileUrl: string | undefined;

  /**文件格式 */
  fileType: string | undefined;
  /** 格式化文件大小 */
  readonly formatSize: string | undefined;
  /** 创建时间 */
  creationTime: moment.Moment;
  id: number;

  constructor(data?: IAttachmentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.type = _data['type'];
      this.modelId = _data['modelId'];
      this.size = _data['size'];
      this.extension = _data['extension'];
      this.fileUrl = _data['fileUrl'];
      this.fileType = _data['fileType'];
      (<any>this).formatSize = _data['formatSize'];
      this.creationTime = _data['creationTime']
        ? moment(_data['creationTime'].toString())
        : <any>undefined;
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): AttachmentDto {
    data = typeof data === 'object' ? data : {};
    let result = new AttachmentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['type'] = this.type;
    data['modelId'] = this.modelId;
    data['size'] = this.size;
    data['extension'] = this.extension;
    data['fileUrl'] = this.fileUrl;
    data['fileType'] = this.fileType;
    data['formatSize'] = this.formatSize;
    data['creationTime'] = this.creationTime
      ? this.creationTime.toISOString()
      : <any>undefined;
    data['id'] = this.id;
    return data;
  }

  clone(): AttachmentDto {
    const json = this.toJSON();
    let result = new AttachmentDto();
    result.init(json);
    return result;
  }
}

export interface IAttachmentDto {
  /** 附件名称 */
  name: string | undefined;
  type: AttachmentType;
  /** 产品型号 */
  modelId: number;
  /** 附件大小Kb */
  size: number;

  /**文件格式 */
  fileType: string;
  /** 文件扩展名 */
  extension: string | undefined;
  /** 文件地址 */
  fileUrl: string | undefined;
  /** 格式化文件大小 */
  formatSize: string | undefined;
  /** 创建时间 */
  creationTime: moment.Moment;
  id: number;
}
export enum DataType {
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
}

export class ProductAttributeDto implements IProductAttributeDto {
  name: string | undefined;
  dataType: DataType;
  /** 是否可为空 */
  nullable: boolean;
  /** 游客显示 */
  isTourist: boolean;
  value: string | undefined;

  constructor(data?: IProductAttributeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.dataType = _data['dataType'];
      this.nullable = _data['nullable'];
      this.isTourist = _data['isTourist'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): ProductAttributeDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProductAttributeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['dataType'] = this.dataType;
    data['nullable'] = this.nullable;
    data['isTourist'] = this.isTourist;
    data['value'] = this.value;
    return data;
  }

  clone(): ProductAttributeDto {
    const json = this.toJSON();
    let result = new ProductAttributeDto();
    result.init(json);
    return result;
  }
}

export interface IProductAttributeDto {
  name: string | undefined;
  dataType: DataType;
  /** 是否可为空 */
  nullable: boolean;
  /** 游客显示 */
  isTourist: boolean;
  value: string | undefined;
}

export class ProductDto implements IProductDto {
  /** 产品编号 */
  productNumber: string | undefined;
  /** 出厂日期 */
  factoryDate: moment.Moment;
  /** 类别 */
  category: string | undefined;
  /** 类型 */
  productType: string | undefined;
  /** 型号 */
  productModel: string | undefined;
  /** 扩展属性 */
  attributes: ProductAttributeDto[] | undefined;
  /** 产品附件 */
  attachments: AttachmentDto[] | undefined;
  /** 调试员 */
  debugger: string | undefined;
  /** 测试员 */
  tester: string | undefined;
  /** 备注 */
  remark: string | undefined;
  id: number;

  constructor(data?: IProductDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productNumber = _data['productNumber'];
      this.factoryDate = _data['factoryDate']
        ? moment(_data['factoryDate'].toString())
        : <any>undefined;
      this.category = _data['category'];
      this.productType = _data['productType'];
      this.productModel = _data['productModel'];
      if (Array.isArray(_data['attributes'])) {
        this.attributes = [] as any;
        for (let item of _data['attributes'])
          this.attributes.push(ProductAttributeDto.fromJS(item));
      }
      if (Array.isArray(_data['attachments'])) {
        this.attachments = [] as any;
        for (let item of _data['attachments'])
          this.attachments.push(AttachmentDto.fromJS(item));
      }
      this.debugger = _data['debugger'];
      this.tester = _data['tester'];
      this.remark = _data['remark'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): ProductDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProductDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['productNumber'] = this.productNumber;
    data['factoryDate'] = this.factoryDate
      ? this.factoryDate.toISOString()
      : <any>undefined;
    data['category'] = this.category;
    data['productType'] = this.productType;
    data['productModel'] = this.productModel;
    if (Array.isArray(this.attributes)) {
      data['attributes'] = [];
      for (let item of this.attributes) data['attributes'].push(item.toJSON());
    }
    if (Array.isArray(this.attachments)) {
      data['attachments'] = [];
      for (let item of this.attachments)
        data['attachments'].push(item.toJSON());
    }
    data['debugger'] = this.debugger;
    data['tester'] = this.tester;
    data['remark'] = this.remark;
    data['id'] = this.id;
    return data;
  }

  clone(): ProductDto {
    const json = this.toJSON();
    let result = new ProductDto();
    result.init(json);
    return result;
  }
}

export interface IProductDto {
  /** 产品编号 */
  productNumber: string | undefined;
  /** 出厂日期 */
  factoryDate: moment.Moment;
  /** 类别 */
  category: string | undefined;
  /** 类型 */
  productType: string | undefined;
  /** 型号 */
  productModel: string | undefined;
  /** 扩展属性 */
  attributes: ProductAttributeDto[] | undefined;
  /** 产品附件 */
  attachments: AttachmentDto[] | undefined;
  /** 调试员 */
  debugger: string | undefined;
  /** 测试员 */
  tester: string | undefined;
  /** 备注 */
  remark: string | undefined;
  id: number;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else
    return _observableThrow(
      new ApiException(message, status, response, headers, null)
    );
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((<any>event.target).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
